import React from 'react';
import { AffordabilityExcludedState } from 'src/AppState/AffordabilityExcludedState';
import { observer } from 'src/utils/mobx-react';
import { LiNotSelected,
    LiSelected,
    Dropdown,
    DropdownPlaceholder,
    DropdownUL,
    DropdownWrapper,
    ChevronDownWrapper,
    AlertBox,
    AlertMessage,
    ModalHeader,
    ModalBody,
    ModalLabel,
    ModalLabelDanger,
    WarningIconWrapper,
    CheckboxDangerWrapper,
    CloseIconWrapper
} from './AffordabilityExcludedRequests.style';
import { CloseIcon } from 'src/assets/icons/OldCloseIcon';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { useClickOutside } from 'src/utils/hooks/useClickOutside';
import { useAppStateContext } from 'src/AppState/AppState';

interface PropsType {
    affordabilityExcludedState: AffordabilityExcludedState,
}

export const AffordabilityExcludedNav = observer('AffordabilityExcludedNav', (props: PropsType): React.ReactElement => {
    const { affordabilityExcludedState } = props;   
    const [setStatusRef] = useClickOutside({ callback: affordabilityExcludedState.handleStatus });
    const [setActionRef] = useClickOutside({ callback: affordabilityExcludedState.handleAction });
    const appState = useAppStateContext();
    let AStatus = JSON.parse(JSON.stringify(affordabilityExcludedState.affordabilityStatus));
    
    if ( AStatus.length > 1 && typeof AStatus !== 'string') {
        AStatus = AStatus.join('').match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
    } 

    return (
        <>
            <DropdownWrapper>
                <Dropdown ref={setStatusRef}>
                    <DropdownPlaceholder onClick={affordabilityExcludedState.handleClickStatus}>
                        {AStatus}
                        <ChevronDownWrapper/>
                    </DropdownPlaceholder >
                    { affordabilityExcludedState.statusDropdown ? 
                        <DropdownUL>
                            {
                                affordabilityExcludedState.getAllTabs().map((element, i) => {
                                    return ( affordabilityExcludedState.affordabilityStatus === element ? 
                                        <LiSelected onClick={(): void => affordabilityExcludedState.handleChangeNav(element)} key={i}>{element}</LiSelected> :
                                        <LiNotSelected onClick={(): void => affordabilityExcludedState.handleChangeNav(element)} key={i} >{element}</LiNotSelected>
                                    );
                                })
                            }
                        </DropdownUL> : null
                    }  
                </Dropdown> 
                <Dropdown ref={setActionRef}>
                    <DropdownPlaceholder onClick={affordabilityExcludedState.handleClickAction}>
                        {'Action'}
                        <ChevronDownWrapper/>
                    </DropdownPlaceholder>
                    { affordabilityExcludedState.actionDropdown ? 
                        <DropdownUL>
                            {
                                <LiNotSelected onClick={(): void => {
                                    affordabilityExcludedState.setAlertBox();
                                    affordabilityExcludedState.actionDropdown = false;
                                }}>{'Mark All Users As Reviewed'}</LiNotSelected>
                            }
                        </DropdownUL> : null
                    }  
                </Dropdown>
            </DropdownWrapper>
            { affordabilityExcludedState.alertBox ? <AlertBox>
                <AlertMessage>
                    <ModalHeader>
                        <p>Mark All Users As Reviewed</p>
                        <CloseIconWrapper>
                            <CloseIcon onClick={affordabilityExcludedState.setAlertBox}/>
                        </CloseIconWrapper>
                    </ModalHeader>
                    <ModalBody>
                        <WarningIconWrapper/>
                        <ModalLabel>Are you sure you want to mark all users as reviewed?</ModalLabel>
                        <p>This action can not be reversed</p>
                        <CheckboxDangerWrapper>
                            <CloseIconWrapper>   
                                <Checkbox labelSide='right' isBackground={!appState.affordabilityExcludedState.dangerCheckbox} onChange={(): void => {
                                    appState.affordabilityExcludedState.dangerCheckbox = !appState.affordabilityExcludedState.dangerCheckbox;
                                }} isChecked={appState.affordabilityExcludedState.dangerCheckbox} isDisabled={false}>
                                    <ModalLabelDanger onClick={appState.affordabilityExcludedState.handleCheckAll}>Mark All Uses As Reviewed</ModalLabelDanger>
                                </Checkbox>
                            </CloseIconWrapper>
                        </CheckboxDangerWrapper>
                    </ModalBody>
                </AlertMessage>
            </AlertBox> : null}
        </>
    );
});
